module.exports = __webpack_public_path__ + "media/bootstrap-icons/x-circle-e5ee3191.svg";